module.exports = __webpack_public_path__ + "4229afe68d4ea62df38751376fa39f2f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/rocket-ship-empty.png
// module id = 327
// module chunks = 0